import type { Config } from "tailwindcss";
import { typography } from "./typography";
import { spacing } from "./spacing";
import { radius } from "./radius";
import { shadow } from "./shadow";

const fontFamily = {
  sans: [...typography.fontFamily.sans],
  mono: [...typography.fontFamily.mono],
};

const fontSize = Object.fromEntries(
  Object.entries(typography.fontSize).map(([key, value]) => [
    key,
    [value[0], { lineHeight: value[1].lineHeight }] as [
      string,
      { lineHeight: string },
    ],
  ]),
);

const fontWeight = { ...typography.fontWeight };
const letterSpacing = { ...typography.letterSpacing };

export const aioTailwindPreset: Partial<Config> = {
  darkMode: ["class", '[data-theme="dark"]'],
  theme: {
    colors: {
      transparent: "transparent",
      current: "currentColor",
      bg: "hsl(var(--bg) / <alpha-value>)",
      "bg-elevated": "hsl(var(--bg-elevated) / <alpha-value>)",
      "bg-subtle": "hsl(var(--bg-subtle) / <alpha-value>)",
      fg: "hsl(var(--fg) / <alpha-value>)",
      "fg-muted": "hsl(var(--fg-muted) / <alpha-value>)",
      muted: "hsl(var(--muted) / <alpha-value>)",
      border: "hsl(var(--border) / <alpha-value>)",
      "border-strong": "hsl(var(--border-strong) / <alpha-value>)",
      accent: "hsl(var(--accent) / <alpha-value>)",
      "accent-fg": "hsl(var(--accent-fg) / <alpha-value>)",
      "accent-strong": "hsl(var(--accent-strong) / <alpha-value>)",
      danger: "hsl(var(--danger) / <alpha-value>)",
      "danger-fg": "hsl(var(--danger-fg) / <alpha-value>)",
      success: "hsl(var(--success) / <alpha-value>)",
      "success-fg": "hsl(var(--success-fg) / <alpha-value>)",
      warning: "hsl(var(--warning) / <alpha-value>)",
      "warning-fg": "hsl(var(--warning-fg) / <alpha-value>)",
      ring: "hsl(var(--ring) / <alpha-value>)",
    },
    fontFamily,
    fontSize,
    fontWeight,
    letterSpacing,
    spacing: { ...spacing },
    borderRadius: { ...radius },
    boxShadow: { ...shadow },
    extend: {
      transitionDuration: {
        instant: "0ms",
        fast: "120ms",
        base: "200ms",
        slow: "320ms",
      },
      transitionTimingFunction: {
        standard: "cubic-bezier(0.2, 0, 0.13, 1.5)",
        decelerate: "cubic-bezier(0, 0, 0.2, 1)",
        accelerate: "cubic-bezier(0.4, 0, 1, 1)",
      },
    },
  },
};
